import { SIGNALS_SECTION_ID } from '../../lib/signals-search.js';

export const TOUR_STORAGE_KEY = 'alison_tour_seen';
export const TOUR_WORKFLOW_ID = 'getTopCreatives';
export const STEP_COUNT_TOKEN = '{steps}';

export const TOUR_STEPS: TourStep[] = [
  {
    key: 'welcome',
    target: null,
    big: true,
    width: 720,
    eyebrow: 'Welcome',
    title: 'Welcome to Alison 2.0',
    body: `Alison watches your accounts, surfaces what changed in your creatives, and runs the analysis for you. You can also ask Alison anything, any time, from the box on Home. ${STEP_COUNT_TOKEN} quick steps.`,
    video: {
      src: '/images/tour/welcome.mp4',
      label: 'A walkthrough of Alison 2.0',
    },
    nextLabel: 'Start',
  },
  {
    key: 'navigation',
    target: '[data-tour="nav"]',
    eyebrow: 'Navigation',
    title: 'Everything lives in the left rail',
    body: 'Home for what changed, Workflows for the analyses you can run, Outcomes for everything you produce.',
  },
  {
    key: 'filters',
    view: 'home',
    target: '[data-tour="filters"]',
    width: 380,
    eyebrow: 'Filters',
    title: 'Choose which creatives you see',
    body: 'Flight stage, client, platform and date range. Every page updates to match.',
  },
  {
    key: 'hero',
    view: 'home',
    target: '[data-tour="hero"]',
    scroll: true,
    eyebrow: 'Portfolio health',
    title: 'Your account at a glance',
    body: 'Health score, where the money goes, budget saved, and your winners and losers.',
  },
  {
    key: 'signals',
    view: 'home',
    target: `#${SIGNALS_SECTION_ID}`,
    scroll: true,
    eyebrow: 'Signals',
    title: 'Start with a Signal',
    body: 'Alison flags what needs attention. Run the suggested workflow straight from the signal, or dismiss it.',
  },
  {
    key: 'workflows',
    view: 'workflows',
    target: `[data-testid="workflow-card-${TOUR_WORKFLOW_ID}"]`,
    scroll: true,
    width: 380,
    eyebrow: 'Workflows',
    title: 'Pick a workflow',
    body: 'Every workflow follows the same path: set up, run, chain into the next one. Results are saved to Outcomes.',
  },
  {
    key: 'outcomes',
    view: 'outcomes',
    target: '[data-tour="outcomes-list"]',
    eyebrow: 'Outcomes',
    title: 'Everything is saved here',
    body: 'Reports, briefs, storyboards and creatives, linked back to the workflow that made them. Help in the top bar opens the Guidebook, the full reference.',
  },
];

export type TourView = 'home' | 'outcomes' | 'workflows' | 'run';

export type TourHostView = TourView | 'other';

export interface TourVideo {
  src: string;
  label: string;
}

export interface TourStep {
  key: string;
  target: string | null;
  view?: TourView;
  scroll?: boolean;
  big?: boolean;
  width?: number;
  video?: TourVideo;
  eyebrow: string;
  title: string;
  body: string;
  nextLabel?: string;
}
